<script setup>
import { computed } from "vue";
import { Link } from "@inertiajs/inertia-vue3";

const props = defineProps({
  active: Boolean,
});

const classes = computed(() =>
  props.active
    ? "block text-sm py-1 pl-4 rounded text-oteo-300 font-bold "
    : "block text-sm py-1 pl-4 text-oteo-300"
);
</script>
<template>
  <Link :class="classes">
    <slot />
  </Link>
</template>
